export default "__VITE_ASSET__H77BP3m6__"